/* eslint-disable no-console */
import axios from 'axios';

import {API_BASE_URL, API_ENDPOINT_JSON} from '../../../config';
import CRUDMethods from '../../../constants/CRUDConstants';
import useUserStore from '../../../store/userStore/userStore';
interface Response {
  key: string;
  name: string;
  email: string;
  auth0UserId: string;
}

interface User {
  _id: string;
  firstName: string;
  lastName: string;
  email: string;
  auth0UserId: string;
}

const getUsersEdit = async (
  userGroupId: string,
  pagination: {page: number; pageSize: number; searchParam: string}
): Promise<{users: Response[]; total: number}> => {
  const {page, pageSize, searchParam} = pagination;
  const token = useUserStore.getState().userToken;
  const {company, facility} = useUserStore.getState().userDetails;

  if (!!userGroupId) {
    try {
      const res = await axios.request({
        method: CRUDMethods.GET,
        url: `${API_BASE_URL}${API_ENDPOINT_JSON.user}/${company}/${facility}/External/${userGroupId}`,
        headers: {
          Authorization: `Bearer ${token}`
        },
        params: {page, pageSize, searchParam}
      });

      const preparedData = res.data.data.users.map((user: User) => ({
        key: user._id,
        name: `${user.firstName} ${user.lastName}`,
        email: user.email,
        auth0UserId: user.auth0UserId
      }));

      return {users: preparedData ?? [], total: res.data.data.total ?? 0};
    } catch (err) {
      return {users: [], total: 10};
    }
  } else {
    return {users: [], total: 10};
  }
};
export default getUsersEdit;
